import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useGamesStore = defineStore('games', () => {
  const fastCashbackGameIds = ref([])
  const competitionsGameIds = ref([])
  const groupListWithImages = ref([])
  const dgaTableIds = ref([])

  function isFastCashbackGamePinia(id) {
    return fastCashbackGameIds.value?.includes(id)
  }

  function isCompetitionGame(id) {
    return competitionsGameIds.value?.includes(id)
  }

  function updateFastCashbackGameIds(payload) {
    fastCashbackGameIds.value = payload
  }

  function updateCompetitionsGameIds(payload) {
    competitionsGameIds.value = payload
  }

  function updateDgaTableIds(payload) {
    dgaTableIds.value = payload
  }

  function setGroupListWithImages(payload) {
    groupListWithImages.value = payload
  }

  return {
    // refs
    fastCashbackGameIds,
    competitionsGameIds,
    groupListWithImages,
    dgaTableIds,
    // computed
    //functions
    updateDgaTableIds,
    isFastCashbackGamePinia,
    isCompetitionGame,
    updateFastCashbackGameIds,
    updateCompetitionsGameIds,
    setGroupListWithImages,
  }
})
